import { useSelector } from 'react-redux'
import { sendAnalyticsEvents } from '@analytics'
import { selectEventsData } from '@store/events'
import { getScreenPath } from '@utils'

export const useSendEvents = ({ screenId = '' }: { screenId?: string } = {}) => {
  const eventsData = useSelector(selectEventsData)

  return (eventName: string, eventParams: { [key: string]: any } = {}, skipAdCabinets = false) => {
    // console.count(eventName) // uncomment to check event duplication
    // console.log(eventName, eventParams)
    const rawScreen = eventParams?.screen_name || screenId || window.location.pathname
    const pathName = {
      screen_name: getScreenPath(String(rawScreen).startsWith('/') ? String(rawScreen) : `/${rawScreen}`),
    }
    const extendedEventsData = { ...eventsData, ...eventParams, ...pathName }

    sendAnalyticsEvents(eventName, extendedEventsData, skipAdCabinets)
  }
}
